
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, NgForm } from '@angular/forms';
import { EventsService } from './events.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import {B2CAdminComponent} from "../../b2c-admin.component";
import {MaintenanceComponent} from "../../../../maintenance/maintenance.component";
import {EventModel} from "./events.model";

@Component({
    selector: 'events-component',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
    providers: [EventsService]
})

export class EventsComponent extends B2CAdminComponent implements OnInit, AfterViewInit {
    @Input() isHome = false;
    @Input() filters;
    items: Object[] = [];
    userRoleId: number;
    clinic: Object = null;
    clinicName: string;
    data: any;
    collapse = true;
    sortUsingApi = false;
    // define what table columns
    // to display [column key, label, css class]
    readonly tableColumns = [
        ['patient_id', 'Patient Id', 'col-xs-2'],
        ['type', 'Type', 'col-xs-2'],
        ['data', 'Info', 'col-xs-5'],
        ['try_count', 'Retries', 'col-xs-1'],
        ['processed', 'Processed', 'col-xs-1'],
        ['created_at', 'Created At', 'col-xs-1']
    ];

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent,
                public service: EventsService)  {
        super(authService, coreService, router, translate, fb, baseService, appService, usersService, homeService, clinicService, maintenanceService, secureApi, maintenanceComponent);
    }

    ngOnInit() {
        super.ngOnInit();

        this.userRoleId = this.authService.user['role_id'];
        this.searchInfo = new EventModel();
        this.token = this.authService.user['token'];

        // sort
        this.sortedColumn = 'created_at_sort';
        this.order = 'desc';
        this.orderField = ['-created_at_sort'];
        this.sortIsActivated = true;

        this.coreService.className = 'fluid';
        this.itemsPerPage = 15;
        if (this.isHome) {
            this.itemsPerPage = 5;
        } else{
            return this.getItems();
        }
    }

    ngAfterViewInit() {
    }

    /**
     * preload mobile number for mobile field
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    getItems() {
        this.initPageSize(this.isHome);
        this.service.getAll(this.filters).subscribe(response => {
            this.isLoading = false;
            this.items = response['items'];
        });
    }

    sortData(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false, this.sortUsingApi);
    }
}
